import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupCustomer } from "../../../Shared/NewForms/NFLookupCustomer";
import { ProductionAndSalesDetailFooter } from "./ProductionAndSalesDetailFooter";

export const ProductionAndSalesDetailMain = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <div className={"panel-body tabs-menu-body main-content-body-right"}>
        <Row>
          <Col sm={6}>
            <NFTextInput title={t("Document#")} fieldName={"documentNumber"} disabled={true} />
          </Col>
          <Col sm={6}>
            <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupWarehouse fieldName={"warehouseId"} title={t("Warehouse")} companyId={watch("companyId")} />
          </Col>
          <Col sm={6}>
            <NFLookupCustomer fieldName={"customerId"} title={t("Customer")} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupDivision companyId={watch("companyId")} fieldName={"divisionId"} title={t("Division")} required />
          </Col>
          <Col sm={6}>
            <NFLookupCurrency fieldName={"currencyId"} title={t("Currency")} required />
          </Col>
        </Row>
      </div>
    </>
  );
};
